import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import OCRScopingJobBulkActionViewModel from '../../SidePanel/OCRScopingJobBulkActionViewModel'

/**
 * Modal to confirm the bulk rerun of scoping jobs.
 */
export default class OCRConfirmBulkRerunModalViewModel extends ModalViewModel {
  constructor(
    public readonly ocrScopingJobBulkActionViewModel: OCRScopingJobBulkActionViewModel,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  confirm = async () => {
    this.close()
    await this.ocrScopingJobBulkActionViewModel.bulkRerun()
  }
}
